import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ConfirmResetPasswordResponse,
  ConfirmResetPasswordInput,
  confirmResetPasswordResponseSchema,
  ErrorResponse,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIConfirmResetPassword = (
  options?: UseMutationOptions<
    ConfirmResetPasswordResponse,
    ErrorResponse,
    ConfirmResetPasswordInput
  >
) =>
  useMutation({
    mutationFn: (values) =>
      post(
        API_ENDPOINTS.CONFIRM_RESET_PASSWORD,
        values,
        confirmResetPasswordResponseSchema
      ),
    ...options,
  })
